module.exports = __webpack_public_path__ + "img/pvc_690g_candy_gruen.9241f77f.jpg";